import firebase from 'firebase/compat/app';

export class ProgramCodeLog {
  public id: string;
  public programId: string;
  public userId: string;
  public timestamp?: firebase.firestore.Timestamp;
}
